import { GetterTree } from "vuex";
import { SiteMonitorCamerasState } from "./types";
import { RootState } from "../types";
import Vue from "vue";

export const getters: GetterTree<SiteMonitorCamerasState, RootState> = {
	getMediaMatrixLayers: state => state.mediaMatrixLayers,
	getMediaMatrixClips: state => state.mediaMatrixClips,
	getAreaCameras: state => state.areaCameras,
	getDeviceControllerCameras: state => state.deviceControllerCameras,
	getDeviceControllerOutputs: state => state.deviceControllerOutputs,
	getDeviceControllerClips: state => state.deviceControllerClips,
	getDeviceControllerStoredFiles: state => state.deviceControllerStoredFiles,
	getLayoutIndex: state => state.layoutIndex,
	getLayouts: state => state.layouts,
	getFilter: state => state.mediaMatrixFilter,
	getAwaitingCamera: state => state.awaitingCamera,
	getAwaitingClip: state => state.awaitingClip,
	getAwaitingStoredFile: state => state.awaitingStoredFile,
	getAllMatrixContents: state => state.matrixContents,
	getMediaMatrixLastChanged: state => state.mediaMatrixLastChanged,
	getMatrixContents: state => {
		return (index: number) => {
			return state.matrixContents[index.toString()];
		};
	},
	getMatrixPushContents: state => {
		return (index: number) => {
			if (state.matrixPushContents === undefined) {
				Vue.set(state.matrixPushContents, index.toString(), null);
			}

			return state.matrixPushContents[index.toString()];
		};
	},
	getMediaMatrixIsNew: state => state.mediaMatrixIsNew,
	getFetchingMatrix: state => state.fetchingMatrix,
	getHighlightCellIndex: state => state.highlightCellIndex,
	getLinkRecord: state => state.linkRecord,
	getWaitingForEvents: state => state.waitingForEvent,
	areaCameras: state => state.areaCameras,
	searchedCameras: state => state.searchedCameras,
	searchedOutputs: state => state.searchedOutputs,
	getShownAuditClips: state => state.shownAuditClips
};
